<span class="nav-alt">
  <a class="nav-link" [href]="url$ | async" id="nav-tu-explained">
    <div class="icon-container">
      <img src="/assets/images/menu/ICN_QuestionMark.svg" alt=""/>
    </div>
    Your Credit File Explained
  </a>
  <hr />
</span>
